import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { SysAdminService } from "../../services/sysadmin.service";
import { ChangeIntsModel } from "../ChangeIntsModel";
import { MSCAddSchoolComponent } from "./mscadd-school/mscadd-school.component";

@Component({
	selector: "caass-manage-school-container-school-table",
	templateUrl: "./manage-school-container-school-table.component.html",
	styleUrls: ["./manage-school-container-school-table.component.css"],
})
export class ManageSchoolContainerSchoolTableComponent implements OnInit {
	constructor(private sysAdminService: SysAdminService, private dialogService: DialogService, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {}

	ngOnChanges() {
		this.errorMessage = "";

		this.loadSchoolList();
	}

	/////////////////////////////////////////
	// Data
	/////////////////////////////////////////

	@Input() SelectedContainer: any;
	@Output() UpdateSchoolCount: EventEmitter<any> = new EventEmitter();
	@Output() UpdateUserGroups: EventEmitter<any> = new EventEmitter();

	lstSchools: any = [];
	SelectedSchools: any = [];

	cols = [
		{ field: "SchoolNumber", header: "User Role" },
		{ field: "SchoolName", header: "User Role" },
	];

	pagerows: any = 5;
	pagefirst: any = 0;

	errorMessage: any = "";

	loading: any = false;
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////
	loadSchoolList() {
		if (this.SelectedContainer == undefined || this.SelectedContainer == null) {
			this.lstSchools = [];
			return;
		}

		this.loading = true;

		var result = this.sysAdminService.SchoolGroupGetSchools(this.SelectedContainer.SchoolGroupID);
		result.subscribe(
			(response) => {
				this.lstSchools = response;
				this.SelectedSchools = [];

				this.loading = false;
			},
			(error) => {}
		);
	}
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		if (this.SelectedContainer == undefined || this.SelectedContainer == null) {
			this.errorMessage = "Select a School Container to add Schools to";
			return;
		}

		var ref = this.dialogService.open(MSCAddSchoolComponent, {
			header: "Add Schools",
			width: "fit-content",
			data: {
				SchoolGroupID: this.SelectedContainer.SchoolGroupID,
				SelectedSchools: this.lstSchools,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadSchoolList();
				this.UpdateSchoolCount.emit(1);
			}
		});
	}

	onRemove() {
		this.errorMessage = "";

		//Keep schools in User groups?
		this.confirmationService.confirm({
			key: "SchoolTable",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Do you want to keep the removed schools in the associated user groups?",
			header: "Remove Schools",
			icon: "fa",
			accept: () => {
				this.AddSchoolsToUserGroups();
			},
			reject: () => {
				this.RemoveSchools();
			},
		});
	}

	AddSchoolsToUserGroups() {
		//Create list of strings
		var lstSchoolID: number[] = [];

		for (var i = 0; i < this.SelectedSchools.length; i++) {
			var next = Number(this.SelectedSchools[i].SchoolID);
			lstSchoolID = [...lstSchoolID, next];
		}

		this.UpdateUserGroups.emit(lstSchoolID);

		this.RemoveSchools();
	}

	RemoveSchools() {
		var lstSchoolID: number[] = [];

		for (var i = 0; i < this.SelectedSchools.length; i++) {
			var next = Number(this.SelectedSchools[i].SchoolID);
			lstSchoolID = [...lstSchoolID, next];
		}

		//Create Query Data
		let data: ChangeIntsModel = {
			MainID: this.SelectedContainer.SchoolGroupID,
			IDList: lstSchoolID,
		};

		//Call SP
		var result = this.sysAdminService.SchoolGroupRemoveSchools(data);
		result.subscribe(
			(response) => {
				this.loadSchoolList();
				this.UpdateSchoolCount.emit(1);
			},
			(error) => {}
		);
	}
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Events
	/////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	/////////////////////////////////////////
}
